import * as act from "./constants";
// import * as selectors from "./selectors";

const uuid4 = require("uuid/v4");

const defaultState = {
  activeprogram: null
};

export default function activeprogram_reducer(state = defaultState, action) {
  switch (action.type) {
    case "SET_ACTIVE_PROGRAM":
      return {
        ...state,
        activeprogram: action.payload
      };

    default:
      return state;
  }
}
